export class EmailFeedbackDto {
    constructor(publicId, emailName, feedbackType, comment, emailSendDate) {
        this.publicId = publicId;
        this.emailName = emailName;
        this.feedbackType = feedbackType;
        this.comment = comment;
        this.emailSendDate = emailSendDate;
    }
}
